import React from 'react'
import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

type VerifySelectedOrganizationErrorProps = {
  onClose: VoidFunction
  open: boolean
}
export function VerifySelectedOrganizationError({ onClose, open }: VerifySelectedOrganizationErrorProps) {
  const { t } = useTranslation()

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="verify-selected-organization-error">
      <AcknowledgeModal
        result="negative"
        title={t('dialog.verifySelectedOrganisation.error.title')}
        description={t('dialog.verifySelectedOrganisation.error.description')}
        buttonText={t('button.done')}
        handleClose={onClose}
        buttonTestId="error-modal-btn"
      />
    </Modal>
  )
}
